import { useAccountContext } from '@ovotech/ui-tools';
import { useMoveOutDateQuery } from '@/src/api';
import { useSupplyPointsQuery } from '@/src/api/kapi/use-supply-points-query';
import { formatFullDate } from '@/src/utils/date';
import { MoveOutDateResponse } from '@/src/types/MoveOut';
import { formatPostalAddress } from '@/src/utils/format-postal-address';

export const useMoveOutData = () => {
  const { accountId } = useAccountContext();

  const moveOutQuery = useMoveOutDateQuery(accountId);

  const supplyPointsQuery = useSupplyPointsQuery();
  const accountSupplyPoints =
    supplyPointsQuery?.data?.account?.accountSupplyPoints;

  const address =
    accountSupplyPoints &&
    accountSupplyPoints.length > 0 &&
    accountSupplyPoints[0].supplyPoint?.address &&
    formatPostalAddress(accountSupplyPoints[0].supplyPoint?.address);

  const moveOutDateFormatted = moveOutQuery.data?.moveOutDate
    ? formatFullDate(
        new Date(
          (moveOutQuery.data as MoveOutDateResponse).moveOutDate as string,
        ),
      )
    : null;

  return {
    isLoading: moveOutQuery.isLoading || supplyPointsQuery.isLoading,
    isError: moveOutQuery.isError || supplyPointsQuery.isError || !address,
    address,
    moveOutDate: moveOutDateFormatted,
  };
};
